import { render, staticRenderFns } from "./CollectionOverview.vue?vue&type=template&id=2d934b7d&scoped=true"
import script from "./CollectionOverview.vue?vue&type=script&lang=js"
export * from "./CollectionOverview.vue?vue&type=script&lang=js"
import style0 from "./CollectionOverview.vue?vue&type=style&index=0&id=2d934b7d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d934b7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d934b7d')) {
      api.createRecord('2d934b7d', component.options)
    } else {
      api.reload('2d934b7d', component.options)
    }
    module.hot.accept("./CollectionOverview.vue?vue&type=template&id=2d934b7d&scoped=true", function () {
      api.rerender('2d934b7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/CollectKanban/collectionOperationDashboard/component/CollectionOverview.vue"
export default component.exports